import React from "react";
import { FormattingDisplayProps } from "models/propTypes/wintFormPropsTypes";
import TextDisplay from "./textDisplay";

function FormattingDisplay<T>(props: FormattingDisplayProps<T>) {
  const text = props.value ? props.formatter(props.value) : "";
  return <TextDisplay {...props} value={text} />;
}

export default FormattingDisplay;
